import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "index"
};
const _hoisted_2 = {
  class: "item-code"
};
const _hoisted_3 = {
  class: "product"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "info"
};
const _hoisted_6 = {
  class: "price",
  style: {
    "font-size": "24px"
  }
};
const _hoisted_7 = {
  class: "info-name"
};
const _hoisted_8 = {
  class: "info-skutext"
};
const _hoisted_9 = {
  class: "footer"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  class: "footer-time"
};
import CustomBar from "@/components/customBar";
import { orders } from "@/api/index";
import { onMounted, ref, onActivated } from "vue";
import Empty from "@/components/empty";
import { useStore } from "@/store/index";
import { usebaseRouter } from "@/utils/hooks";
import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "Order"
});
export default /*@__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const {
      navigate,
      route
    } = usebaseRouter();
    const store = useStore();
    const list = ref([]);
    const logistics = item => {
      store.$state.orderInfo = item;
      navigate('logistics');
    };
    const getList = () => {
      orders().then(res => {
        list.value = res;
      });
    };
    onActivated(() => {
      if (!route.meta.isBack) {
        getList();
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(CustomBar), {
        title: "我的订单"
      }), _createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: index
        }, [_createElementVNode("div", _hoisted_2, [_createTextVNode("订单编号：" + _toDisplayString(item.orderNo) + " ", 1), _createElementVNode("span", null, _toDisplayString(item.stateName), 1)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
          class: "img",
          src: item.goodsPic,
          alt: ""
        }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[0] || (_cache[0] = _createElementVNode("span", {
          class: "s",
          style: {
            "font-size": "18px"
          }
        }, "￥", -1)), _createTextVNode(_toDisplayString(item.priceYuan), 1)]), _createElementVNode("div", _hoisted_7, _toDisplayString(item.goodsName), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, _toDisplayString(item.spec), 1), _createElementVNode("div", null, "x" + _toDisplayString(item.qty), 1)])])]), _createElementVNode("div", _hoisted_9, [item.expressNo ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "footer-btn",
          onClick: $event => logistics(item)
        }, "查看物流", 8, _hoisted_10)) : (_openBlock(), _createElementBlock("div", _hoisted_11)), _createElementVNode("div", _hoisted_12, _toDisplayString(item.createTime), 1)])]);
      }), 128))]), list.value.length == 0 ? (_openBlock(), _createBlock(_unref(Empty), {
        key: 0,
        text: "暂无订单"
      })) : _createCommentVNode("", true)], 64);
    };
  }
});